import React, { useCallback, useContext, useEffect, useState } from "react";
import { CustomDrawer } from "../../../../../styles/CustomDrawerStyles";
import AttendedEmployeesList from "./AttendedEmployeesList";
import { Header } from "./MeetingDetails";
import { empType, PageFor } from "../../../../../utils/Enum.types";
import { Title } from "../../../../../stories/Title/Title";
import { AppContext } from "../../../../../context/context";
import { useLazyQuery } from "@apollo/client";
import {
  GetMomAttCountResult,
  GetMomAttCountVars,
  GetMomDetailsResult,
  GetMomDetailsVars,
  GetVendorNotesResult,
  GetVendorNotesVars,
} from "../queries/types";
import {
  GetMomAttCount,
  GetMomDetails,
  GetVendorNotes,
} from "../queries/query";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {
  CustomModal,
  
} from "../../../../../utils/UtilFunctions";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";
import Pdf from "../../../../../images/DownloadPdf.svg";
import Image from "../../../../../images/DownloadImage.svg";
import Doc from "../../../../../images/WordDocument.svg";
import Xls from "../../../../../images/Excel.svg";
import Assign from "../../../../../images/Assign.svg";
import EditProfile from "../../../../../images/Edit.svg";

import {
  ViewAssetStylesRaiseTicket,
  ViewMoreFileStyles,
} from "../../../../../styles/CustomModalStyles";
import { idAndFlagType } from "../../../../../utils/formTypes";
import { EMPTY_STRING, emptyIdAndModal } from "../../../../../utils/constants";
import Edit from "../planning/Edit";
import ViewVendorNotes from "./ViewVendorNotes";

import Close from "../../../../../images/Close.svg";
import { Button } from "../../../../../stories/Button/Button";
import MeetingHeader from "../customComponents/MeetingHeader";
interface Props {
  pageType: PageFor;
  momID: number;
  latest: boolean;
  setPresentDetails: React.Dispatch<React.SetStateAction<boolean>>;
}

export enum docTypeEnum {
  COMMENT = "COMMENT",
  VENDOR_RESPONSE = "VENDOR_RESPONSE",
  PMU_RESPONSE = "PMU_RESPONSE",
}
const PreviousMeetingDetails = ({
  pageType,
  momID,
  latest,
  setPresentDetails,
}: Props) => {
  const [attendanceDetails, setAttendanceDetails] = useState(false);
  const { state } = useContext(AppContext);
  const [pmuFilesModal, setPmuFilesModal] = useState(false);
  const [vendorFilesModal, setVendorFilesModal] = useState(false);
  const [pmuResponseFilesModal, setPmuResponseFilesModal] = useState(false);

  const [attachmentId, setAttachmentId] = useState(0);

  const [commentFiles, setPmuFiles] = useState<string[]>([]);
  const [vendorDocs, setVendorDocs] = useState<string[]>([]);
  const [pmuResponseDocs, setPmuResponseDocs] = useState<string[]>([]);

  const { customer_id, projectID, momID: presentMomId } = useUrlParams();

  const [GetDetails, { data }] = useLazyQuery<
    GetMomDetailsResult,
    GetMomDetailsVars
  >(GetMomDetails);

  const [GetNotes, { data: notesData }] = useLazyQuery<
    GetVendorNotesResult,
    GetVendorNotesVars
  >(GetVendorNotes);

  useEffect(() => {
    if (customer_id && momID && projectID) {
      GetNotes({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest,
        },
      });
    }
  }, [GetNotes, momID, projectID, customer_id, state.empSubType, latest]);

  const [fillDetails, setFillDetails] =
    useState<idAndFlagType>(emptyIdAndModal);

  const [checkAttMarked, { data: checkAttMarkedStatus }] = useLazyQuery<
    GetMomAttCountResult,
    GetMomAttCountVars
  >(GetMomAttCount);
  useEffect(() => {
    if (customer_id && momID && projectID) {
      checkAttMarked({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest,
        },
      });
    }
  }, [customer_id, momID, projectID, checkAttMarked, latest]);

  useEffect(() => {
    if (customer_id && momID && projectID) {
      GetDetails({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest,
        },
      });
    }
  }, [GetDetails, momID, projectID, customer_id, latest]);

  const downloadFile = (
    ext: string,
    index: number,
    commentId: number,
    doc: docTypeEnum
  ) => {
    let filename = "";

    switch (doc) {
      case docTypeEnum.COMMENT:
        filename = `${customer_id}/momDetails/${momID}/${projectID}/${commentId}_${index}.${ext}`;
        break;
      case docTypeEnum.VENDOR_RESPONSE:
        filename = `${customer_id}/momDetails/${momID}/${projectID}/vendorResponses/${commentId}_${index}.${ext}`;
        break;
      case docTypeEnum.PMU_RESPONSE:
        filename = `${customer_id}/momDetails/${momID}/${projectID}/pmuResponses/${commentId}_${index}.${ext}`;
        break;
      default:
        break;
    }
    if (filename) getDownloadUrl(filename, true);
  };

  const chooseFile = useCallback(
    (file: string, index: number, commentId: number, doc: docTypeEnum) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({ image }: { image: string }) => {
        return (
          <div
            className="meeting-details--left--block--attachments--file"
            onClick={() => downloadFile(ext!, index, commentId, doc)}
          >
            {file} <img src={image} alt="not found" />
          </div>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={Image} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );

  const chooseFileMore = useCallback(
    (file: string, index: number, commentId: number, doc: docTypeEnum) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({ image }: { image: string }) => {
        return (
          <>
            <div
              className="meeting-details--left--block--attachments--file"
              onClick={() => downloadFile(ext!, index, commentId, doc)}
            >
              <span> {file}</span> <img src={image} alt="not found" />
            </div>
          </>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={Image} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );
  
  return (
    <>
 
      {(pageType === PageFor.GENERAL || pageType === PageFor.VIEW) && (
        <div className={`meeting-details--left--header`}>
          <MeetingHeader
            fill={pageType === PageFor.GENERAL}
            momId={momID}
            latest={latest}
          />
        </div>
      )}
            {pageType === PageFor.MODAL && (
          <div className="change-password__title">
            <Title>History </Title>
            <img src={Close} alt="" onClick={() => setPresentDetails(false)} />
          </div>
        )}
   
      <div className="meeting-details--left--block">

        <div
          className={`meeting-details--left--block--header${
            pageType === PageFor.GENERAL ? "--vendor" : ""
          }`}
        >
          {Header.map((res, index) => {
            return (
              <li
                className="meeting-details--left--block--header--li"
                key={index}
              >
                {res}
              </li>
            );
          })}
          {pageType === PageFor.GENERAL && <li>Actions</li>}
        </div>
        <div className="meeting-details--left--block--sub">
          {data
            ? data.GetMomDetails.map((res, index) => {
                let pmuFiles: string[] = [];
                let pmuVisibleFiles: string[] = [];
                let pmuRemainingCount = 0;

                if (res.pmuComments.trim() !== EMPTY_STRING) {
                  pmuFiles = res.pmuDocuments.split(";");
                  pmuVisibleFiles = pmuFiles.slice(0, 2);
                  pmuRemainingCount = pmuFiles.length - 2;
                }
                let vendorFiles: string[] = [];
                let vendorVisibleFiles: string[] = [];
                let vendorRemainingCount = 0;

                let pmuResponseFiles: string[] = [];
                let pmuResponseVisibleFiles: string[] = [];
                let pmuResponseRemainingCount = 0;

                if (res.vendorDocuments.trim() !== EMPTY_STRING) {
                  vendorFiles = res.vendorDocuments.split(";") || [];
                  vendorVisibleFiles = vendorFiles.slice(0, 2);
                  vendorRemainingCount = vendorFiles.length - 2;
                }
                if (res.pmuResponseDocuments.trim() !== EMPTY_STRING) {
                  pmuResponseFiles = res.pmuResponseDocuments.split(";") || [];
                  pmuResponseVisibleFiles = pmuResponseFiles.slice(0, 2);
                  pmuResponseRemainingCount = pmuResponseFiles.length - 2;
                }
                return (
                  <div
                    key={index}
                    className="meeting-details--left--block--sub--li"
                  >
                    <div
                      className={`meeting-details--left--block--list${
                        state.empSubType === empType.VENDOR_MANAGER
                          ? "--vendor"
                          : ""
                      } ${
                        res.vendorResponse && res.vendorResponse.length
                          ? ` green-border`
                          : " red-border"
                      }`}
                    >
                      <span className="meeting-details--left--block--slno">
                        {index + 1} 
                      </span>

                      <div className="meeting-details--left--block--attachments">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: res.pmuComments,
                          }}
                        />
                        <div>
                          {pmuVisibleFiles.map((file, i) => {
                            const filename = file.split("/").pop();
                            return (
                              <div key={i}>
                                {chooseFile(
                                  filename!,
                                  i,
                                  res.id,
                                  docTypeEnum.COMMENT
                                )}
                              </div>
                            );
                          })}

                          {pmuRemainingCount > 0 && (
                            <button
                              onClick={() => {
                                setAttachmentId(res.id);
                                setPmuFiles(res.pmuDocuments.split(";"));
                                setPmuFilesModal(!pmuFilesModal);
                              }}
                            >
                              +{pmuRemainingCount} more
                            </button>
                          )}
                        </div>

                        <CustomModal
                          style={ViewMoreFileStyles}
                          isOpen={pmuFilesModal}
                          onRequestClose={() => setPmuFilesModal(false)}
                          contentComponent={
                            <div className="meeting-details--left--block--more-files">
                              <div className="meeting-details--left--block--more-files-t">
                                <Title>Uploaded Files</Title>
                                <img
                                  src={Close}
                                  alt=""
                                  onClick={() =>
                                    setPmuFilesModal(!pmuFilesModal)
                                  }
                                />
                              </div>
                              <div className="meeting-details--left--block--more-files--block">
                                <ul>
                                  {commentFiles.map((files, index) => {
                                    const filename = files.split("/").pop();

                                    return (
                                      <li key={index}>
                                        {chooseFileMore(
                                          filename!,
                                          index,
                                          attachmentId,
                                          docTypeEnum.COMMENT
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                              <Button
                                mode="cancel"
                                onClick={() => setPmuFilesModal(!pmuFilesModal)}
                              />
                            </div>
                          }
                        />
                      </div>

                      {/* {res.response.emp_details.map((emp, index) => {
                    return (
                      <div>
                        <div className="meeting-details--left--block--emp-details">
                          <img src={emp.img} alt="" />
                          <b>{emp.name}</b>
                          <span>({emp.desn})</span>
                        </div>
                        <b>{emp.details}</b>
                      </div>
                    );
                  })} */}

                      <div className="meeting-details--left--block--attachments">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: res.vendorResponse,
                          }}
                        />
                        <div>
                          {vendorVisibleFiles.map((file, i) => {
                            const filename = file.split("/").pop();
                            return (
                              <div key={i}>
                                {chooseFile(
                                  filename!,
                                  i,
                                  res.id,
                                  docTypeEnum.VENDOR_RESPONSE
                                )}
                              </div>
                            );
                          })}

                          {vendorRemainingCount > 0 && (
                            <button
                              onClick={() => {
                                setAttachmentId(res.id);
                                setVendorDocs(res.vendorDocuments.split(";"));
                                setVendorFilesModal(!vendorFilesModal);
                              }}
                            >
                              +{vendorRemainingCount} more
                            </button>
                          )}
                        </div>

                        <CustomModal
                          style={ViewMoreFileStyles}
                          isOpen={vendorFilesModal}
                          onRequestClose={() =>
                            setVendorFilesModal(!vendorFilesModal)
                          }
                          contentComponent={
                            <>
                              <div className="meeting-details--left--block--more-files">
                                <div className="meeting-details--left--block--more-files-t">
                                  <Title>Uploaded Files</Title>
                                  <img
                                    src={Close}
                                    alt=""
                                    onClick={() =>
                                      setVendorFilesModal(!vendorFilesModal)
                                    }
                                  />
                                </div>
                                <div className="meeting-details--left--block--more-files--block">
                                  <ul>
                                    {vendorDocs.map((files, index) => {
                                      const filename = files.split("/").pop();
                                      return (
                                        <li key={index}>
                                          {chooseFile(
                                            filename!,
                                            index,
                                            res.id,
                                            docTypeEnum.VENDOR_RESPONSE
                                          )}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                                <Button
                                  mode="cancel"
                                  onClick={() =>
                                    setVendorFilesModal(!vendorFilesModal)
                                  }
                                />
                              </div>
                            </>
                          }
                        />
                      </div>
                      <div className="meeting-details--left--block--attachments">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: res.pmuResponse,
                          }}
                        />
                        <div>
                          {pmuResponseVisibleFiles.map((file, i) => {
                            const filename = file.split("/").pop();
                            return (
                              <div key={i}>
                                {chooseFile(
                                  filename!,
                                  i,
                                  res.id,
                                  docTypeEnum.PMU_RESPONSE
                                )}
                              </div>
                            );
                          })}

                          {pmuResponseRemainingCount > 0 && (
                            <button
                              onClick={() => {
                                setAttachmentId(res.id);
                                setPmuResponseDocs(
                                  res.pmuResponseDocuments.split(";")
                                );
                                setPmuResponseFilesModal(
                                  !pmuResponseFilesModal
                                );
                              }}
                            >
                              +{pmuResponseRemainingCount} more
                            </button>
                          )}
                        </div>

                        <CustomModal
                          style={ViewMoreFileStyles}
                          isOpen={pmuResponseFilesModal}
                          onRequestClose={() =>
                            setPmuResponseFilesModal(!pmuResponseFilesModal)
                          }
                          contentComponent={
                            <>
                              <div className="meeting-details--left--block--more-files">
                                <div className="meeting-details--left--block--more-files-t">
                                  <Title>Uploaded Files</Title>
                                  <img
                                    src={Close}
                                    alt=""
                                    onClick={() =>
                                      setPmuResponseFilesModal(
                                        !pmuResponseFilesModal
                                      )
                                    }
                                  />
                                </div>
                                <div className="meeting-details--left--block--more-files--block">
                                  <ul>
                                    {pmuResponseDocs.map((files, index) => {
                                      const filename = files.split("/").pop();
                                      return (
                                        <li key={index}>
                                          {chooseFile(
                                            filename!,
                                            index,
                                            res.id,
                                            docTypeEnum.PMU_RESPONSE
                                          )}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                                <Button
                                  mode="cancel"
                                  onClick={() =>
                                    setPmuResponseFilesModal(
                                      !pmuResponseFilesModal
                                    )
                                  }
                                />
                              </div>
                            </>
                          }
                        />
                      </div>

                      {pageType === PageFor.GENERAL && (
                        <>
                          {res.vendorResponse && res.vendorResponse.length ? (
                            <button
                              className="meeting-details--left--block--update"
                              onClick={() =>
                                setFillDetails({
                                  flag: true,
                                  id: res.id,
                                })
                              }
                            >
                              Update <img src={EditProfile} alt="" />
                            </button>
                          ) : (
                            <button
                              className="meeting-details--left--block--fill"
                              onClick={() =>
                                setFillDetails({
                                  flag: true,
                                  id: res.id,
                                })
                              }
                            >
                              Fill <img src={Assign} alt="" />
                            </button>
                          )}
                        </>
                      )}
                      {/* {pageType === PageFor.VIEW &&
                        state.empSubType === empType.PMU && (
                          <button
                            className="meeting-details--left--block--copy"
                            onClick={() => fallbackCopy(res.pmuComments)}
                          >
                            Copy <img src={Copy} alt="" />
                          </button>
                        )} */}
                    </div>
                  </div>
                );
              })
            : null}

          <ViewVendorNotes momID={momID} latest={latest} />
        </div>
      </div>
           <div className="meeting-details--left--sub-h">
        <div className="meeting-details--left--sub-h--att">
          <b onClick={() => setAttendanceDetails(!attendanceDetails)}>
            {checkAttMarkedStatus
              ? Number(checkAttMarkedStatus.GetMomAttCount.empCount) +
                Number(checkAttMarkedStatus.GetMomAttCount.inviteesCount)
              : 0}
            Members
          </b>
          <div>
            <span className="font-green">Present</span>
          </div>
        </div>
     
        <div className="overall-total-count">
          Total Points :{" "}
          <b>
            {data
              ? data.GetMomDetails.length +
                (notesData ? notesData.GetVendorNotes.length : 0)
              : 0}
          </b>
        </div>
      </div>
      <CustomDrawer
        anchor="right"
        open={attendanceDetails}
        onClose={() => setAttendanceDetails(!attendanceDetails)}
      >
        <AttendedEmployeesList
          setModalFlag={setAttendanceDetails}
          momId={momID}
          latest={latest}
        />
      </CustomDrawer>

      <CustomModal
        style={ViewAssetStylesRaiseTicket}
        isOpen={fillDetails.flag}
        onRequestClose={() => setFillDetails(emptyIdAndModal)}
        contentComponent={
          <Edit
            setModalFlag={setFillDetails}
            idModalFlag={fillDetails}
            fieldType={docTypeEnum.COMMENT}
          />
        }
      />
    </>
  );
};

export default PreviousMeetingDetails;
